 import { TmlScheduleGenerator } from "../components/bussched/schedules/tml/TmlScheduleGenerator";
import { ViaPortoScheduleGenerator } from "../components/bussched/schedules/viaPorto/ViaPortoScheduleGenerator";
import { CarrisScheduleGenerator } from "../components/bussched/schedules/carris/CarrisScheduleGenerator";
import { SmtucScheduleGenerator } from "../components/bussched/schedules/smtuc/SmtucScheduleGenerator";

export class CustomBusSchedManager {
    getGenerator(name) {
        let generatorComponent = null;

        switch (name.toUpperCase()) {
            case "VIA PORTO":
                generatorComponent = ViaPortoScheduleGenerator;
                break;

            case "CARRIS":
                generatorComponent = CarrisScheduleGenerator;
                break;

            case "TML":
            case "RDL":
                generatorComponent = TmlScheduleGenerator;
                break;

            case "SMTUC":
                generatorComponent = SmtucScheduleGenerator;
                break;

            default:
                break;
        }

        return generatorComponent;
    }

    getGeneratorConfigs(name) {
        let configs = null;

        switch (name.toUpperCase()) {
            case "TML":
            case "RDL":
                configs = {
                    presentReferenceDate: true
                };
                break;

            default:
                configs = {};
                break;
        }

        return configs;
    }
}

export const customBusSchedManager = new CustomBusSchedManager();



// WEBPACK FOOTER //
// ./src/app/CustomBusSchedManager.js